import React from 'react';
import { useNavigate } from 'react-router-dom';

const menuItems = [
  { name: 'Home', path: '/' },
  { name: 'Dashboard', path: '/dashboard' },
  { name: 'Notice', path: '/dashboard/notice' },
  { name: 'Reword', path: '/dashboard/reword' },
  { name: 'Result Print', path: '/dashboard/result-card' },
  { name: 'SMS', path: '/dashboard/bulkSms' },
  { name: 'Attendance', path: '/dashboard/attendance' },
  { name: 'Exam', path: '/dashboard/examControl' },
];

const AllMenus = () => {
  // const [me, meLoading, meRefetch, meError] = useContext(MeContext);
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    document.getElementById('all-manu').checked = false; // Close modal
  };

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains('modal')) {
      document.getElementById('all-manu').checked = false;
    }
  };

  return (
    <div>
      <input type="checkbox" id="all-manu" className="modal-toggle" />
      <div
        className="modal modal-bottom sm:modal-middle"
        onClick={handleOutsideClick}
      >
        <div className="modal-box sm:!w-11/12 !max-w-[500px] relative pb-8 mb-10 bg-blue-100 h-auto px-4 py-b pt-3 rounded-lg shadow-lg">
          <label
            htmlFor="all-manu"
            className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
          >
            ✕
          </label>

          <h3 className="text-xl font-semibold text-blue-900 mb-5 ">
            📋 All Menus
          </h3>

          {/* Menu Items */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
            {menuItems.map((item, idx) => (
              <button
                key={idx}
                onClick={() => handleNavigate(item.path)}
                className="flex flex-col items-center justify-center gap-2 border border-blue-300 bg-white hover:bg-blue-50 text-blue-800 font-medium p-2 py-1 rounded-lg shadow-sm hover:shadow-md transition-all duration-200"
              >
                {/* Icon (you can use real icons here if you have Heroicons or FontAwesome) */}
                {/* <div className="text-3xl">📁</div> */}
                <span className="text-sm sm:text-base">{item.name}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllMenus;
